import React from "react";
import _ from "lodash";

import ModalWrapper from "../../../common/ModalWrapper";
import { validateUnitSettings } from "./UPRSegmentationHelper";
import PriceUnit from "./PriceUnit";
import UnitSettingEditView from "./UnitSettingEditView";
import LoadingUI from "components/common/LoadingUI";

import { FaPlus } from "react-icons/fa";

class UnitSettingModal extends React.PureComponent {
  constructor(props) {
    super(props);

    const { currentRule } = this.props;

    this.state = {
      previewSettings: currentRule.unit_segmented_price_settings, // should be valid

      isLoading: false,
      isVerified: false,
      errors: null,
      priceErrors: [],
    };

    this.handleValidate = this.handleValidate.bind(this);
    this.handleSettingChanged = this.handleSettingChanged.bind(this);
    this.handleSettingDeleted = this.handleSettingDeleted.bind(this);
    this.handleAddSetting = this.handleAddSetting.bind(this);
    this.handleUnitPriceValid = this.handleUnitPriceValid.bind(this);
    this.handleVerification = this.handleVerification.bind(this);
    this.handleSaveUnitSettings = this.handleSaveUnitSettings.bind(this);
  }

  handleValidate() {
    const { previewSettings, priceErrors } = this.state;
    const errors = validateUnitSettings(previewSettings) || [];
    const priceErrList = _.flatMap(priceErrors, (err, idx) =>
      _.map(err || [], (d) => `[${idx + 1}] ${d}`)
    );
    const errList = [...errors, ...priceErrList];

    this.setState({
      errors:
        errList.length > 0
          ? _.sortBy(errList, (str) => {
              const match = str.match(/^\[(\d+)]/);
              return match ? parseInt(match[1]) : Infinity;
            })
          : null,
    });
  }

  handleSettingChanged(obj, idx) {
    const { previewSettings, isVerified } = this.state;
    const newSettings = _.map(previewSettings, (s, i) => {
      if (i === idx) {
        return obj;
      }
      return s;
    });
    this.setState({ previewSettings: newSettings }, () => {
      if (isVerified) this.handleValidate();
    });
  }

  handleAddSetting() {
    const { previewSettings } = this.state;
    const newSetting = {
      id: "",
      name: "",
      units: [],
      prices: [],
      detector_prices: [],
    };

    this.setState({
      previewSettings: [...(previewSettings || []), newSetting],
      isVerified: false,
    });
  }

  handleSettingDeleted(idx) {
    const { previewSettings, priceErrors, isVerified } = this.state;
    const newSettings = _.filter(previewSettings, (s, i) => i !== idx);
    const newPriceErrors = _.filter(priceErrors, (s, i) => i !== idx);
    this.setState(
      {
        previewSettings: newSettings,
        priceErrors: newPriceErrors,
      },
      () => {
        if (isVerified) this.handleValidate();
      }
    );
  }

  handleUnitPriceValid(list, idx) {
    const errList = [...this.state.priceErrors];
    errList[idx] = list.length === 0 ? null : list;

    this.setState({
      priceErrors: errList,
    });
  }

  handleVerification(cb) {
    const { previewSettings } = this.state;
    this.setState({ isLoading: true });
    const loadingTime =
      (previewSettings || []).length > 5
        ? 1000
        : (previewSettings || []).length * 200;

    this.handleValidate();

    setTimeout(() => {
      this.setState(
        {
          isLoading: false,
          isVerified: true,
        },
        () => {
          if (cb) cb();
        }
      );
    }, loadingTime);
  }

  handleSaveUnitSettings() {
    const { handleSaveUnitSettings } = this.props;
    const { previewSettings, isVerified } = this.state;

    if (!isVerified) {
      this.handleVerification(() => {
        const { errors, isVerified } = this.state;
        if (isVerified && !errors) {
          handleSaveUnitSettings(previewSettings);
        }
      });
      return;
    } else {
      const { errors } = this.state;
      if (!errors) {
        handleSaveUnitSettings(previewSettings);
      }
    }
  }

  render() {
    const {
      networkInfo,
      formErrMsg,
      isUnitSettingModalOpen,
      currentRule,
      priceSuggestions,
      isSaving,
      handleRemoveUnitSettings,
      handleCloseModal,
    } = this.props;

    const { previewSettings, validPriceList, errors, isVerified, isLoading } =
      this.state;

    const isValid = _.every(validPriceList, (d) => d) && errors === null;

    const allUnits = _.uniq(_.flatMap(previewSettings || [], (s) => s.units));

    return (
      <ModalWrapper
        isOpen={isUnitSettingModalOpen}
        showCloseFooter={false}
        handleClose={handleCloseModal}
        customOverlayStyle={{ zIndex: 100 }}
        width="80%"
        title={{
          label: "Unit Price Settings for ",
          highlight: `${currentRule.id} ${currentRule.name}`,
        }}
      >
        <div>
          <div className="mb-2 mt-4 flex flex-col gap-2">
            <div className="w-full">
              <table className="border table w-full table-fixed text-sm font-normal">
                <thead className="border-b bg-gray-200 text-xs text-blue-800">
                  <tr>
                    <th
                      className="border px-2 py-1 text-right"
                      style={{ width: "4rem" }}
                    >
                      ID
                    </th>
                    <th className="border px-2 py-1 text-left ">Name</th>
                    <th
                      className="border px-2 py-1 text-left "
                      style={{ width: "6rem" }}
                    >
                      Optimization
                    </th>
                    <th className="border w-2/3 px-2 py-1 text-left">Prices</th>
                  </tr>
                </thead>
                <tbody className="bg-white  text-gray-900">
                  <tr className="border-b">
                    <td className="border px-2 py-1 text-right">
                      {currentRule.id}
                    </td>

                    <td className="border break-all px-2 py-1 text-left font-medium">
                      {currentRule.name}
                    </td>

                    <td className="border px-2 py-1 text-left">
                      {currentRule.optimization}
                    </td>

                    <td className="border px-1 py-1 text-left text-xs">
                      <div className="divide-x flex gap-2">
                        <div className="w-1/4 px-2">
                          <span className="font-semibold text-gray-800">
                            Prices:
                            {currentRule.optimization !== "dt" && (
                              <span>({currentRule.prices.length})</span>
                            )}
                          </span>{" "}
                          <br></br>
                          {currentRule.optimization !== "dt" ? (
                            <div className="flex w-full flex-wrap gap-1 pb-1">
                              {currentRule.prices.map((p, idx) => {
                                return (
                                  <PriceUnit
                                    price={p}
                                    key={`${idx}-${p}`}
                                    readOnly={true}
                                  ></PriceUnit>
                                );
                              })}
                            </div>
                          ) : (
                            "-"
                          )}
                        </div>
                        <div className="w-1/4 px-2">
                          <span className="font-semibold text-gray-800">
                            Detector Prices: (
                            {currentRule.detector_prices.length})
                          </span>
                          <br></br>
                          <div className="flex w-full flex-wrap gap-1 pb-1">
                            {currentRule.detector_prices.map((p, idx) => {
                              return (
                                <PriceUnit
                                  price={p}
                                  key={`${idx}-${p}`}
                                  readOnly={true}
                                ></PriceUnit>
                              );
                            })}
                          </div>
                        </div>
                        <div className="w-1/4 px-2">
                          <span className="font-semibold text-gray-800">
                            Catchall Prices:{" "}
                            {currentRule.catchall_prices && (
                              <>({currentRule.catchall_prices.length})</>
                            )}
                          </span>
                          <br></br>{" "}
                          {currentRule.catchall_prices ? (
                            <div className="flex w-full flex-wrap gap-1 pb-1">
                              {currentRule.catchall_prices.map((p, idx) => {
                                return (
                                  <PriceUnit
                                    price={p}
                                    key={`${idx}-${p}`}
                                    readOnly={true}
                                  ></PriceUnit>
                                );
                              })}
                            </div>
                          ) : (
                            "-"
                          )}
                        </div>
                        <div className="w-1/4 px-2">
                          <span className="font-semibold text-gray-800">
                            X Prices:{" "}
                            {currentRule.x_prices && (
                              <>({currentRule.x_prices.length})</>
                            )}
                          </span>
                          <br></br>{" "}
                          {currentRule.x_prices ? (
                            <div className="flex w-full flex-wrap gap-1 pb-1">
                              {currentRule.x_prices.map((p, idx) => {
                                return (
                                  <PriceUnit
                                    price={p}
                                    key={`${idx}-${p}`}
                                    readOnly={true}
                                  ></PriceUnit>
                                );
                              })}
                            </div>
                          ) : (
                            "-"
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="flex w-full gap-4">
              <div className="w-2/3">
                <div className="font-bold text-gray-700">
                  Unit Price Settings:{" "}
                  {previewSettings && `(${previewSettings.length})`}
                </div>
                <div
                  className="overflow-y-auto bg-gray-100 p-2"
                  style={{ height: "400px" }}
                >
                  {previewSettings && (
                    <div className="mb-2 flex flex-col gap-4">
                      {previewSettings.map((rule, idx) => {
                        const unitPriceSuggestions = _.get(priceSuggestions, [
                          "suggestionsBySegment",
                          currentRule.id,
                          "pricesByUnit",
                          rule.id,
                        ]);
                        return (
                          <UnitSettingEditView
                            key={idx}
                            index={idx}
                            rule={rule}
                            isVerified={isVerified}
                            ref={this.editUnitSettingRef}
                            networkId={networkInfo.networkId}
                            suggestion={unitPriceSuggestions}
                            optimization={currentRule.optimization}
                            allUnits={allUnits}
                            handleRuleChange={(obj) =>
                              this.handleSettingChanged(obj, idx)
                            }
                            handleRuleDelete={() =>
                              this.handleSettingDeleted(idx)
                            }
                            handleValidChanged={(list) =>
                              this.handleUnitPriceValid(list, idx)
                            }
                          ></UnitSettingEditView>
                        );
                      })}
                    </div>
                  )}
                  <button
                    className={`rounded shadow w-full bg-blue-500 py-1 text-center font-semibold text-gray-100 hover:bg-blue-700`}
                    onClick={this.handleAddSetting}
                  >
                    <div className="flex items-center justify-center gap-2 text-sm">
                      <FaPlus></FaPlus>
                      Add New Setting
                    </div>
                  </button>
                </div>
              </div>
              <div className="w-1/3">
                <div className="font-semibold text-gray-700">
                  Verification Result:{" "}
                  {errors && isVerified && (
                    <>
                      (<span className="text-red-600">{errors.length}</span>)
                    </>
                  )}
                </div>
                <div
                  className="relative flex flex-col gap-1 overflow-y-auto"
                  style={{ height: "400px" }}
                >
                  {isLoading && (
                    <>
                      <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-100">
                        <LoadingUI iconOnly={true}></LoadingUI>
                      </div>
                    </>
                  )}
                  {isVerified ? (
                    <>
                      {errors && errors.length > 0 ? (
                        errors.map((errMsg) => {
                          return (
                            <div
                              key={errMsg}
                              className="bg-red-100 px-2 py-1 text-red-600"
                            >
                              {errMsg}
                            </div>
                          );
                        })
                      ) : (
                        <div className="bg-green-100 px-2 py-1 text-green-600">
                          Settings valid
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="bg-gray-100 px-2 py-1 text-gray-600">
                      --
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="border-t -mx-6 px-6 pt-4">
            <div className="flex items-center justify-end">
              <div className="flex flex-row-reverse gap-4">
                <button
                  type="button"
                  className={`px-4 py-2 ${
                    isSaving || !isValid
                      ? "cursor-not-allowed bg-gray-400 text-gray-800"
                      : "bg-blue-500 text-white hover:bg-blue-700"
                  }  rounded shadow font-semibold`}
                  onClick={this.handleSaveUnitSettings}
                  disabled={isSaving || !isValid}
                >
                  {isSaving ? "Saving..." : "Save Unit Settings"}
                </button>

                <button
                  type="button"
                  className={`px-4 py-2 ${
                    isVerified
                      ? "cursor-not-allowed bg-gray-400 text-gray-800"
                      : "bg-blue-500 text-white hover:bg-blue-700"
                  }  rounded shadow font-semibold`}
                  onClick={() => this.handleVerification()}
                  disabled={isVerified}
                >
                  Verification
                </button>

                <button
                  type="button"
                  className={`px-4 py-2 ${
                    isSaving || (previewSettings || []).length === 0
                      ? "cursor-not-allowed bg-gray-400 text-gray-800"
                      : "bg-red-500 text-white hover:bg-red-700"
                  }  rounded shadow font-semibold`}
                  onClick={handleRemoveUnitSettings}
                  disabled={isSaving || (previewSettings || []).length === 0}
                >
                  Remove Unit Settings
                </button>

                <button
                  type="button"
                  disabled={isSaving}
                  className={`px-4 py-2 text-blue-700 ${
                    isSaving ? "cursor-not-allowed" : ""
                  }`}
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="text-red-600">{formErrMsg}</div>
          </div>
        </div>
      </ModalWrapper>
    );
  }
}

export default UnitSettingModal;
